import { useToast } from '@/shared/hooks'

/**
 * Хелпер для показа toast с ошибкой
 * @param error - сообщение ошибки (строка) или объект ошибки
 *
 * @example
 * const addToastError = useAddToastError()
 * addToastError('Ошибка загрузки данных')
 * addToastError(new Error('Не удалось подключиться'))
 */
export function useAddToastError() {
  const { addToast } = useToast()

  return (error: string | Error | unknown) => {
    const message = typeof error === 'string'
      ? error
      : error instanceof Error
        ? error.message
        : 'Неизвестная ошибка'

    addToast('Ошибка!', message, 'error')
  }
}

/**
 * Хелпер для показа toast с успехом
 * @param message - сообщение успеха
 *
 * @example
 * const addToastSuccess = useAddToastSuccess()
 * addToastSuccess('Данные сохранены')
 */
export function useAddToastSuccess() {
  const { addToast } = useToast()

  return (message: string) => {
    addToast('Успех!', message, 'success')
  }
}
